// File: src/components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import '../css/HomePage.css'; // Import CSS để nhận style Footer

export default function Footer() {
    return (
        <footer className="homepage-footer">
            <div className="footer-grid">
                <div className="footer-col">
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20 }}>
                        <div style={{ width: 32, height: 32, background: '#2563EB', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 'bold', fontSize: 16 }}>S</div>
                        <span style={{ fontWeight: '800', fontSize: '1.4rem', color: '#111827' }}>SkillMatch</span>
                    </div>
                    <p style={{ color: '#6b7280', fontSize: '0.95rem', lineHeight: 1.6 }}>
                        Nền tảng tuyển dụng công nghệ cao, giúp kết nối ứng viên và nhà tuyển dụng một cách chính xác nhất thông qua đánh giá năng lực thực tế.
                    </p>
                    
                    {/* --- KẾT NỐI VỚI CHÚNG TÔI (MẠNG XÃ HỘI) --- */}
                    <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
                        {/* Facebook Icon */}
                        <a 
                            href="https://www.facebook.com/profile.php?id=61587197257010" 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="social-icon-footer"
                            title="Theo dõi Fanpage SkillMatch"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                            </svg>
                        </a>

                        {/* Email Icon (Sử dụng đúng thẻ <path> và thuộc tính d) */}
                        <a 
                            href="mailto:skillmatchvn@gmail.com" 
                            className="social-icon-footer"
                            title="Gửi email cho chúng tôi"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                            </svg>
                        </a>
                    </div>
                </div>
                
                <div className="footer-col">
                    <h4>Về chúng tôi</h4>
                    <ul>
                        <li><Link to="/about">Giới thiệu</Link></li>
                        <li><Link to="/contact">Liên hệ</Link></li>
                        <li><Link to="/terms">Điều khoản sử dụng</Link></li>
                    </ul>
                </div>

                <div className="footer-col">
                    <h4>Ứng viên</h4>
                    <ul>
                        <li><Link to="/jobs">Tìm việc làm</Link></li>
                        <li><Link to="/candidate/profile">Tạo CV AI</Link></li>
                        <li><Link to="/blog">Blog nghề nghiệp</Link></li>
                    </ul>
                </div>

                <div className="footer-col">
                    <h4>Doanh nghiệp</h4>
                    <ul>
                        <li><Link to="/register-business">Đăng tin tuyển dụng</Link></li>
                        <li><Link to="/register-business">Tìm hồ sơ ứng viên</Link></li>
                        <li><Link to="/upgrade-account">Báo giá dịch vụ</Link></li>
                    </ul>
                </div> 
            </div>

            <style>{`
                .social-icon-footer {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 40px;
                    height: 40px;
                    background-color: #F3F4F6;
                    color: #4B5563;
                    border-radius: 50%;
                    transition: all 0.3s ease;
                    text-decoration: none;
                }
                .social-icon-footer:hover {
                    background-color: #2563EB;
                    color: white;
                    transform: translateY(-4px);
                    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
                }
            `}</style>
        </footer>
    );
}